import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { IdentificationVerificationV1CaseDetails } from './v1';
import { SectionLayout } from './v1/section-layout';

interface IdentificationVerificationVersionRouterProps {}

export const IdentificationVerificationVersionRouter: React.FC<IdentificationVerificationVersionRouterProps> = () => {
  return (
    <Routes>
      <Route path="" element={<SectionLayout />} />
      <Route path="v1/*" element={<IdentificationVerificationV1CaseDetails />} />
    </Routes>
  );
};
